const base = 'workspace';

export const trackingIds = {
  glsItem: `${base}-gls-item`,
  glsManageSettings: `${base}-gls-manage-settings`,
  createNew: `${base}-create-new`,
  edit: `${base}-edit`,
  delete: `${base}-delete`,
  editLocations: `${base}-edit-locations`,
  editUsers: `${base}-edit-users`,
};
